module.exports = __webpack_public_path__ + "img/ic-setting.6a168c39.svg";